import {chartMusterdepot} from "./components/charts/emi-hsi-hse-chart";

import ChartJS from 'chart.js/auto';

window.ChartJS = ChartJS

jQuery(document).ready(function () {
    initFAQ();
    initMobileMenuNavigation();
    initMobileFooterNavigation();
    initBrowserCheck();
    initNotificationMessage();
    initLikeButton();
    initCheckboxCounter();
    initMobileDropdownBlog();
    initCheckboxBasedOnURL();
    initStockDropdown();
    initReviewForm();
    initContactFileDrag();
    initLetterClubTile();
    initFileRemove();
    initExpansionTile();
    initShowWoocommerceReviews();
    initSingleProductAccordion();
    initPriceSlide();
    initClubScrollDown();
    initAssignAccordingCounterClass();
    initFadeInElements();
    initChartMusterdepotDropdown();
    initReviewDropdown();
    loadSelectImgSrc();

    //AJAX
    ajaxUpdateBlogFilter();
    initUpdateCartItems();
    initFilterShopPage();
    initProductFaq();
    initCustomShopSelect();


    loadChartForFrontpage('NDX');
    loadChartForSingleProduct();
});

function ajaxUpdateBlogFilter() {

    let postsPerPage = 8;

    jQuery('.load-more').on('click', function () {
        postsPerPage += 4;
        updatePosts();
    })

    // Handle checkbox state change
    jQuery('.checkbox-wrapper input[type="checkbox"]').on('change', function () {
        updatePosts();
    });

    // Handle clicking on the wrapper
    jQuery('.checkbox-wrapper').on('click', function (e) {
        // If the clicked element was not the checkbox, toggle the checkbox state
        if (!jQuery(e.target).is('input[type="checkbox"]')) {
            const checkbox = jQuery(this).find('input[type="checkbox"]');
            checkbox.prop('checked', !checkbox.prop('checked')).change();
        }
    });

    // Attach change event listener to sort filter
    let currentSortValue = 'newest';
    jQuery('.custom-sort-dropdown-item').on('click', function () {
        jQuery('.custom-sort-dropdown-item').removeClass('active');
        jQuery(this).addClass('active');

        currentSortValue = jQuery(this).data('sort-value');
        jQuery('#custom-sort-active-item').text(jQuery(this).text());
        updatePosts();
    });

    let searchTimeout;
    jQuery('#search-filter input[type="search"]').keyup(function () {
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        searchTimeout = setTimeout(function () {
            updatePosts();
        }, 300);
    });

    const searchForm = document.querySelector('.search-form');
    if (searchForm) {
        searchForm.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });
    }

    // Function to send AJAX request and update posts
    function updatePosts() {
        let filter = jQuery('.search-form').serializeArray();
        filter.push({name: 'sort', value: currentSortValue});
        jQuery.ajax({
            type: 'POST', url: ajax.url, dataType: 'json', data: {
                action: 'updateBlogFilter', filter: filter, postPerPage: postsPerPage
            }, success: function (data) {
                jQuery('.ajax-filter').html(data.data.posts);
                if (data.data.loadMore === true) {
                    jQuery('.load-more').addClass('active');
                } else {
                    jQuery('.load-more').removeClass('active');
                }
            }, error: function (xhr) {
                console.log(xhr.statusText + ': ' + xhr.responseText);
            }
        });
    }
}

function updateCounterDisplay(counterSelector, checkboxSelector) {
    const container = jQuery(counterSelector).closest('.checkboxes-container');
    const checkbox = container.find(checkboxSelector);
    const counter = jQuery(counterSelector);
    const length = checkbox.filter(':checked').length;

    if (length > 0) {
        counter.text('(' + length + ')');
        counter.addClass('active');
    } else {
        counter.text('');
        counter.removeClass('active');
    }
}

function initCheckboxCounter() {
    updateCounterDisplay('#selected-items', '.checkbox-wrapper input[type="checkbox"]');
    updateCounterDisplay('#selected-tags', '.checkbox-wrapper input[type="checkbox"]');

    jQuery('.checkbox-wrapper input[type="checkbox"]').on('change', function () {
        updateCounterDisplay('#selected-items', '.checkbox-wrapper input[type="checkbox"]');
        updateCounterDisplay('#selected-tags', '.checkbox-wrapper input[type="checkbox"]');
    });
}

function initCheckboxBasedOnURL() {
    const pathParts = window.location.pathname.split('/');
    let categorySlug = '';

    if (pathParts.includes('kategorie')) {
        categorySlug = pathParts[pathParts.indexOf('kategorie') + 1];
    }

    if (categorySlug) {
        const categoryCheckbox = jQuery(`input[name="category[]"][value="${categorySlug}"]`);
        if (!categoryCheckbox.prop('checked')) {
            categoryCheckbox.prop('checked', true);
        }
    }

    updateCounterDisplay('#selected-items', '.checkbox-wrapper input[type="checkbox"]');
}

function initFAQ() {
    jQuery('.faq-container .drop-down-title').on('click', function (e) {
        e.stopPropagation();

        if (jQuery(this).hasClass("dt-active")) {
            jQuery(".drop-down-title").removeClass("dt-active");
            jQuery(this).addClass("dt-active");
            jQuery(this).next(".drop-down-content").slideToggle("normal");
            jQuery(this).toggleClass("dt-active");
        } else {
            jQuery(".drop-down-title").removeClass("dt-active");
            jQuery(".drop-down-content").slideUp("normal");
            jQuery(this).toggleClass("dt-active");
            jQuery(this).next(".drop-down-content").slideToggle("normal");
        }
    });

    const dropdownItem = jQuery('.faq-mobile-dropdown .faq-mobile-dropdown-item');
    const selectedItemContainer = jQuery('.faq-mobile-dropdown #faq-mobile-active-item');

    // This is kind of a hack to make the current item active. The active item of the invisible desktop sidebar
    // is selected and then the mobile dropdown item with the same text is selected and marked as active
    const selectedSidebarItem = $('.help-nav .selected').text();
    dropdownItem.each(function (index, item) {
        if ($(item).text() === selectedSidebarItem) {
            $(item).addClass('active');
            selectedItemContainer.html(selectedSidebarItem);
        }
    });

    if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
        jQuery('.faq-mobile-dropdown-title').on('click', function (e) {
            e.stopPropagation();
            const $wrapper = jQuery(this).closest('.faq-mobile-dropdown-wrapper');

            if ($wrapper.hasClass('open')) {
                $wrapper.removeClass('open');
                $wrapper.find('.faq-mobile-dropdown-list').css({
                    'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
                });
                $wrapper.find('.faq-mobile-dropdown-icon').css('transform', 'rotate(0deg)');
                jQuery(this).css('background-color', 'white')
            } else {
                $wrapper.addClass('open');
                jQuery(this).next('.faq-mobile-dropdown-list').css({
                    'max-height': '500px', 'opacity': '1', 'pointer-events': 'auto',
                });
                jQuery(this).find('.faq-mobile-dropdown-icon').css('transform', 'rotate(180deg)');
                jQuery(this).css('background-color', '#F9FAFC')
            }
        });

        // Add click event to document to close dropdown if clicked outside of it
        jQuery(document).on('click', function (e) {
            const $wrapper = jQuery('.faq-mobile-dropdown-wrapper');

            if ($wrapper.hasClass('open')) {
                const $target = jQuery(e.target);
                if (!$target.closest('.faq-mobile-dropdown-wrapper').length) {
                    $wrapper.removeClass('open');
                    $wrapper.find('.faq-mobile-dropdown-list').css({
                        'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
                    });
                    $wrapper.find('.faq-mobile-dropdown-icon').css('transform', 'rotate(0deg)');
                    $wrapper.find('.faq-mobile-dropdown-title').css('background-color', 'white')
                }
            }
        });
    } else {
        jQuery('.faq-mobile-dropdown-title').on('mouseenter', function () {
            jQuery(this).css('background-color', '#F9FAFC');

            jQuery(this).next('.faq-mobile-dropdown-list').css({
                'max-height': '500px', 'opacity': '1', 'pointer-events': 'auto'
            });
            jQuery(this).find('.faq-mobile-dropdown-icon').css('transform', 'rotate(180deg)');
        });
        jQuery('.faq-mobile-dropdown-wrapper').on('mouseleave', function () {
            jQuery(this).find('.faq-mobile-dropdown-title').css('background-color', 'white')

            jQuery(this).find('.faq-mobile-dropdown-list').css({
                'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
            });
            jQuery(this).find('.faq-mobile-dropdown-icon').css('transform', 'rotate(0deg)');
        });
    }

    dropdownItem.on('click', function () {
        const thisDropdownItem = $(this);
        dropdownItem.removeClass('active');
        thisDropdownItem.addClass('active');
        selectedItemContainer.html(thisDropdownItem.text());
    })
}

function initMobileMenuNavigation() {
    const listWithChildrenLink = jQuery('#menu-footermenue-mobil .menu-item-has-children > a');

    listWithChildrenLink.removeAttr('href');
    listWithChildrenLink.addClass('pointer');

    jQuery('#menu-footermenue-mobil .menu-item-has-children').click(function (e) {
        e.stopPropagation();
        jQuery(this).toggleClass('flex');
        let $el = $('ul', this);
        jQuery('.mobile-navigation .menu-item-has-children .sub-menu').not($el).slideUp();
        $el.stop(true, true).slideToggle(400);

        let element = $(this);
        element.toggleClass('active');
        jQuery('.menu-item-has-children').not(element).removeClass('active');
    });

}

function initMobileFooterNavigation() {

    const listWithChildrenLink = jQuery('.mobile-navigation .menu-item-has-children > a');

    listWithChildrenLink.removeAttr('href');
    listWithChildrenLink.addClass('pointer');

    jQuery('.mobile-navigation .menu-item-has-children').click(function (e) {
        e.stopPropagation();
        jQuery(this).toggleClass('flex');
        let $el = $('ul', this);
        jQuery('.mobile-navigation .menu-item-has-children .sub-menu').not($el).slideUp();
        $el.stop(true, true).slideToggle(400);

        let element = $(this);
        element.toggleClass('active');
        jQuery('.menu-item-has-children').not(element).removeClass('active');
    });
}

function initNotificationMessage() {
    const messageContainer = document.querySelector('.footer-notification');

    if (messageContainer) {
        const closeButton = document.querySelector('.footer-notification .close');
        const hideDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

        const hideTimestamp = localStorage.getItem('notificationBannerDismissedTimestamp');
        if (hideTimestamp && new Date().getTime() < parseInt(hideTimestamp) + hideDuration) {
            messageContainer.classList.remove('active');
        } else {
            setTimeout(function () {
                messageContainer.classList.add('active');
            }, 1000);
        }

        if (closeButton) {
            closeButton.addEventListener('click', function () {
                messageContainer.classList.remove('active');
                // Store the current timestamp in localStorage when closing the notification
                localStorage.setItem('notificationBannerDismissedTimestamp', new Date().getTime().toString());
            });
        }
    }
}

function initLikeButton() {
    const likeButton = jQuery('.like-button');
    likeButton.on('click', function (event) {
        event.preventDefault();
        let element = $(this);
        element.toggleClass('active');
    })
}

function initStockDropdown() {
    const dropdownItems = document.querySelectorAll('.dropdown .dropdown-item');
    const selectedItemContainer = document.querySelector('.dropdown #active-item');

    if (dropdownItems.length) {
        dropdownItems[0].classList.add('active');
        selectedItemContainer.textContent = dropdownItems[0].textContent;
    }

    let dropdownTitle = document.querySelector('.stock-dropdown .dropdown-title');
    let isDropdownOpen = false;

    if (dropdownTitle) {
        dropdownTitle.addEventListener('mouseenter', toggleDropdown);
        dropdownTitle.addEventListener('click', toggleDropdown);
    } else {
        return;
    }

    function toggleDropdown() {
        isDropdownOpen = !isDropdownOpen;
        if (isDropdownOpen) {
            this.style.backgroundColor = 'rgb(249, 250, 252)';
            const dropdownList = this.nextElementSibling;
            dropdownList.style.maxHeight = '500px';
            dropdownList.style.opacity = '1';
            dropdownList.style.pointerEvents = 'auto';

            const dropdownIcon = this.querySelector('.dropdown-icon');
            dropdownIcon.style.transform = 'rotate(180deg)';
        } else {
            closeDropdown();
        }
    }

    function closeDropdown() {
        const dropdownTitle = document.querySelector('.stock-dropdown .dropdown-title');
        const dropdownList = dropdownTitle.nextElementSibling;
        const dropdownIcon = dropdownTitle.querySelector('.dropdown-icon');

        dropdownTitle.style.backgroundColor = 'white';
        dropdownList.style.maxHeight = '0';
        dropdownList.style.opacity = '0';
        dropdownList.style.pointerEvents = 'none';
        dropdownIcon.style.transform = 'rotate(0deg)';
        isDropdownOpen = false;
    }

    window.addEventListener('click', function (e) {
        const dropdownTitle = document.getElementById('dropdown-title');
        const dropdownList = document.getElementById('dropdown-list');
        if ((dropdownTitle && !dropdownTitle.contains(e.target)) && (dropdownList && !dropdownList.contains(e.target))) {
            closeDropdown();
        }
    });

    document.querySelector('.stock-dropdown .dropdown-wrapper').addEventListener('mouseleave', function () {
        closeDropdown();
    });

    dropdownItems.forEach(item => {
        item.addEventListener('click', function () {
            dropdownItems.forEach(dItem => dItem.classList.remove('active'));
            this.classList.add('active');
            selectedItemContainer.textContent = this.textContent;

            let symbol = 'DAX';
            switch (this.textContent) {
                case "DAX":
                    symbol = "GDAXI";
                    break;
                case "NASDAQ 100":
                    symbol = "NDX";
                    break;
                case "SDAX":
                    symbol = "SDAXI";
                    break;
                case "MSCI Emerging Markets":
                    symbol = "MME=F";
                    break;
                case "MSCI World":
                    symbol = "MWL=F";
                    break;
            }
            loadChartForFrontpage(symbol);

            closeDropdown();
        });
    });
}

function initBrowserCheck() {
    function isIE() {
        let userAgent = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        return userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1;
    }

    /* Create an alert to show if the browser is IE or not */
    if (isIE()) {
        jQuery('.ie-check').show();
    }
}

function initReviewForm() {
    const feedback = jQuery('.feedback-show');
    feedback.on('click', function () {
        const thisElement = jQuery('.write-rating');
        thisElement.toggleClass('active');
    });

    jQuery('#review-form').on('submit', function (e) {
        e.preventDefault();

        let form_data = jQuery(this).serialize();
        jQuery.ajax({
            url: ajax.url, method: 'POST', data: form_data, dataType: 'json', success: function (result) {
                if (result.status === 'success') {
                    jQuery('#review-rate').empty().html('<div class="entry-title entry-title--underline"><h3 class="thank-you-title">' + result.messages.title + '</h3></div><p class="thank-you-message">' + result.messages.success + '</p>').hide().fadeIn(500);
                } else if (result.status === 'invalid') {
                    let list_messages = '';
                    jQuery.each(result.messages.invalid, function (index, value) {
                        list_messages += '<lI>' + value + '</li>';
                    });
                    list_messages = '<ul>' + list_messages + '</ul>';
                    jQuery('#review-rate-messages').empty().html('<div class="invalid-message">' + list_messages + '</div>').hide().fadeIn(300);
                    reviewFormhighlightErrorFields(list_messages);
                } else if (result.status === 'error') {
                    jQuery('#review-rate-messages').empty().html('<div class="invalid-message">' + result.messages.error + '</div>').hide().fadeIn(300);
                } else {
                }
            }, error: function (error) {
                console.log(error)
            }
        });
    });

    jQuery('.review-rating').on('click', 'label', function () {
        jQuery('input[name=review_rate]').removeAttr("checked");
        jQuery('#' + jQuery(this).attr('for')).attr('checked', 'checked');
        updateStarImagesBasedOnCheckedInput();
    });

    review_stars();
}

let review_stars = function () {
    let starRatingInput = jQuery('.star-rating-input');
    let filledStar = starRatingInput.data('filled-star');
    let emptyStar = starRatingInput.data('empty-star');

    jQuery('.star-rating-input label').on('mouseover', function () {
        let hoveredStarValue = jQuery(this).data('star');
        for (let i = 1; i <= 5; i++) {
            let starImg = jQuery('#star-' + i + ' img');
            starImg.attr('src', i <= hoveredStarValue ? filledStar : emptyStar);
        }
    });

    starRatingInput.on('mouseout', function () {
        updateStarImagesBasedOnCheckedInput();
    });
};

let updateStarImagesBasedOnCheckedInput = function () {
    let starRatingInput = jQuery('.star-rating-input');
    let filledStar = starRatingInput.data('filled-star');
    let emptyStar = starRatingInput.data('empty-star');

    let checkedValue = jQuery('input[name=review_rate]:checked').val();
    for (let i = 1; i <= 5; i++) {
        let starImg = jQuery('#star-' + i + ' img');
        starImg.attr('src', i <= checkedValue ? filledStar : emptyStar);
    }
};

function reviewFormhighlightErrorFields(list_messages) {
    jQuery('#review-form-first-name, #review-form-last-name, #review-form-email, #review-form-message').css('border', '1px solid #ECEFF4');

    if (list_messages.includes('Geben Sie bitte Ihren Vornamen ein.')) {
        jQuery('#review-form-first-name').css('border', '1px solid #FF294A');
    }
    if (list_messages.includes('Geben Sie bitte Ihren Nachnamen ein.')) {
        jQuery('#review-form-last-name').css('border', '1px solid #FF294A');
    }
    if (list_messages.includes('Geben Sie bitte Ihre E-Mail-Adresse ein.')) {
        jQuery('#review-form-email').css('border', '1px solid #FF294A');
    }
    if (list_messages.includes('Schreiben Sie bitte eine Bewertung.')) {
        jQuery('#review_content').css('border', '1px solid #FF294A');
    }
    if (list_messages.includes('Bitte akzeptieren Sie die Datenschutzerklärung.')) {
        jQuery('#data-privacy-checkbox').css('border', '1px solid #FF294A');
    }
}

function updateCartItems() {

    jQuery.ajax({
        url: ajax.url, method: 'POST', dataType: 'json', data: {
            action: 'update_cart_count'
        }, success: function (data) {
            const container = jQuery('.cart .items');
            container.html(data.data);
        }, error: function (error) {
            console.log(error)
        }
    });

}

function shopPageFilter(filter) {
    jQuery.ajax({
        url: ajax.url, method: 'POST', dataType: 'json', data: {
            action: 'shop_page_filter', sorting: filter.sorting, categories: filter.categories
        }, success: function (data) {
            const container = jQuery('.post-type-archive-product .products');
            container.html(data.data);
        }, error: function (error) {
            console.log(error)
        }
    });
}

function initUpdateCartItems() {

    jQuery('body').on('click', 'a.remove', function () {
        updateCartItems();
    })
}

function initFilterShopPage() {
    let filter = {
        categories: [], sorting: ''
    }

    const checkboxes = jQuery('.post-type-archive-product input[type="checkbox"]');
    const sortingSelect = jQuery('.post-type-archive-product .custom-sort-dropdown-item');

    checkboxes.on('change', function () {
        filter.categories = [];
        checkboxes.each(function (index, checkbox) {
            if (checkbox.checked) filter.categories.push(jQuery(checkbox).val());
        });
        shopPageFilter(filter);
    });

    sortingSelect.on('click', function () {
        sortingSelect.removeClass('active');
        jQuery(this).addClass('active');

        filter.sorting = jQuery(this).attr('data-sort-value');
        shopPageFilter(filter);
    });
}

function initContactFileDrag() {
    const mainContainer = jQuery('.page-template-page-kontakt');
    if (mainContainer.length !== 0) {
        const dropContainer = document.getElementById("dropcontainer");
        if (dropContainer != null && dropContainer.length !== 0) {
            const fileInput = document.getElementById("file");
            dropContainer.addEventListener("dragover", (e) => {
                // prevent default to allow drop
                e.preventDefault()
            }, false);
            dropContainer.addEventListener("dragenter", () => {
                dropContainer.classList.add("drag-active")
            });

            dropContainer.addEventListener("dragleave", () => {
                dropContainer.classList.remove("drag-active")
            });

            dropContainer.addEventListener("drop", (e) => {
                e.preventDefault()
                dropContainer.classList.remove("drag-active")
                fileInput.files = e.dataTransfer.files
                const [file] = e.dataTransfer.files
                // Get the file name and size
                const {name: fileName} = file
                console.log(fileName)
                document.querySelector('.file-name').textContent = fileName
            });
            fileInput.addEventListener('change', (e) => {
                // Get the selected file
                const [file] = e.target.files;
                // Get the file name and size
                const {name: fileName, size} = file;
                // Convert size in bytes to kilobytes
                const fileSize = (size / 1000).toFixed(2);
                // Set the text content
                document.querySelector('.file-name').textContent = `${fileName} - ${fileSize}KB`;
            });
        }
    }
}

function initClubScrollDown() {
    const clubContainer = document.querySelector('.page-template-page-club');
    if (clubContainer) {
        document.getElementById('view-content').addEventListener('click', function () {
            const target = document.querySelector('.topic-preview');
            window.scrollTo({
                top: target.getBoundingClientRect().top + window.pageYOffset - 180,
                behavior: 'smooth'
            });
        });

        document.getElementById('compare').addEventListener('click', function () {
            const target = document.querySelector('.compare-club');
            window.scrollTo({
                top: target.getBoundingClientRect().top + window.pageYOffset - 180,
                behavior: 'smooth'
            });
        });
    }
}

function initLetterClubTile() {
    const letterContainer = document.querySelector('.letter-group');
    const clubContainer = document.querySelector('.club-groups');
    if (letterContainer || clubContainer) {
        const coll = document.getElementsByClassName("letter-header");
        for (let i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                const content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }
    }
}

function initFileRemove() {
    jQuery('#file').change(function () {
        const len = $('.img-remove').length;
        if (len < 1) {
            $('.file-name').append('<a class="img-remove" id="remvImg" style="" onclick="removeimg()" data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Remove Image"><img class="rmv-img" src="/wp-content/themes/binside/assets/images/icons/Close.svg" alt="Close"></a>');
        }
    });

    jQuery('#dropcontainer').on('drop', function () {
        const len = $('.img-remove').length;

        if (len < 1) {
            $('.file-name').append('<a class="img-remove" id="remvImg" style="" onclick="removeimg()" data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Remove Image"><img class="rmv-img" src="/wp-content/themes/binside/assets/images/icons/Close.svg" alt="Close"></a>');
        }
    });
}


function initExpansionTile() {
    const postContainer = jQuery('.single-post');
    const faqContainer = jQuery('.page-template-page-faq');
    const priceContainer = jQuery('.page-template-page-preise');
    const clubContainer = jQuery('.page-template-page-club');
    const letterContainer = jQuery('.page-template-page-stock-letter');
    const stockLetter = jQuery('.single-boersen-brief');
    if (postContainer.length !== 0 || faqContainer.length !== 0 || priceContainer.length !== 0 || clubContainer.length !== 0 || letterContainer.length !== 0 || stockLetter.length !== 0) {
        const coll = document.getElementsByClassName("collapsible");
        let i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }
            });
        }
    }
}

function initShowWoocommerceReviews() {
    const button = jQuery('.woocommerce-Reviews-title');
    const container = jQuery('#review_form_wrapper');

    button.on('click', function () {
        button.addClass('hide');
        container.addClass('active');
    })
}

function initSingleProductAccordion() {
    const button = jQuery('.accordion-headline');

    button.on('click', function () {
        jQuery(this).toggleClass('active');
        jQuery(this).siblings('ul').toggleClass('active');
    })
}

function initProductFaq() {
    const button = jQuery('.faq-title');

    button.on('click', function () {
        jQuery(this).toggleClass('active');
        jQuery(this).siblings('.faq-content').toggleClass('active');
    });
}

function initPriceSlide() {
    const mainContainer = document.querySelector('.page-template-page-preise');

    if (mainContainer) {
        const letter = document.querySelector(".letter-slide-btn");
        const club = document.querySelector(".club-slide-btn");
        const slides = document.querySelectorAll(".slide-content");

        // Function to set active state
        function setActive(btn1, btn2, slideToShow, slideToHide) {
            btn1.classList.add('active');
            btn2.classList.remove('active');
            slideToShow.style.display = 'flex';
            slideToHide.style.display = 'none';
        }

        letter.addEventListener("click", function () {
            if (!this.classList.contains("active")) {
                setActive(letter, club, slides[0], slides[1]);
            }
        });

        club.addEventListener("click", function () {
            if (!this.classList.contains("active")) {
                setActive(club, letter, slides[1], slides[0]);
            }
        });

        // Set the initial state based on URL hash
        const hashValue = window.location.hash;
        if (hashValue === '#letters') {
            setActive(letter, club, slides[0], slides[1]);
        } else if (hashValue === '#clubs') {
            setActive(club, letter, slides[1], slides[0]);
        } else {
            setActive(letter, club, slides[0], slides[1]);
        }
    }
}

function loadChartForFrontpage(symbol) {
    if (window.location.pathname === '/') {
        jQuery.ajax({
            type: 'POST', url: ajax.url, data: {
                action: 'request_chart', symbol: symbol,
            }, success: function (data) {
                jQuery('#frontpage_chartResult').html(data);
            }, error: function (xhr) {
                console.log(xhr.statusText + ': ' + xhr.responseText);
            }
        });
    }
}

function loadChartForSingleProduct() {
    const pathname = window.location.pathname;
    let symbol;

    switch (pathname) {
        case '/produkt/emerging-markets-investor/':
            symbol = 'MME=F';
            break;
        case '/produkt/hot-stocks-investor/':
            symbol = 'NDX';
            break;
        case '/produkt/hot-stocks-europe/':
            symbol = 'GDAXI';
            break;
        case '/produkt/optionsschein-trader/':
            symbol = 'MWL=F';
            break;
        default:
            return;
    }

    jQuery.ajax({
        type: 'POST',
        url: ajax.url,
        data: {
            action: 'request_chart',
            symbol: symbol,
        },
        success: function (data) {
            jQuery('#frontpage_chartResult').html(data);
        },
        error: function (xhr) {
            console.log(xhr.statusText + ': ' + xhr.responseText);
        }
    });
}

function initCustomShopSelect() {
    const selectField = jQuery('.archive select[name="sort"]');
    const customSelectCurrent = jQuery('.archive .custom-select .custom-current-selection');
    const customOption = jQuery('.archive #custom-dropdown div');

    customOption.on('click', function () {
        const id = jQuery(this).attr('id');
        customOption.removeClass('active');
        jQuery(this).addClass('active');
        selectField.val(id);
        selectField.trigger('change');
        const text = (jQuery(this).text());
        customSelectCurrent.text(text);
    })
}

function initAssignAccordingCounterClass() {
    const container = jQuery('.product-accordion');
    if (container.length) {
        const length = container.children().length;
        if (length <= 2) container.addClass('special-container');
    }
}

function initFadeInElements() {
    if (window.innerWidth > 1200) {
        window.addEventListener("scroll", function () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            let scrollThreshold = 1380;
            if (scrollTop > scrollThreshold) {
                jQuery('.teaser-1').addClass('active');
                let cumulativeTimeout = 0; // Initialize cumulative timeout

                for (let i = 2; i <= 4; i++) {
                    cumulativeTimeout += 1000; // Increment by 1 second
                    setTimeout(function () {
                        jQuery('.teaser-' + i).addClass('active');
                    }, cumulativeTimeout);
                }
            }
        });
    }
}

// Yes this is bad and code duplication with initFAQ() but time is running out + I am tired
function initChartMusterdepotDropdown() {
    const dropdownItem = jQuery('.performance-musterdepot-dropdown .performance-musterdepot-dropdown-item');
    const selectedItemContainer = jQuery('.performance-musterdepot-dropdown #performance-musterdepot-active-item');

    if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
        jQuery('.performance-musterdepot-dropdown-title').on('click', function (e) {
            e.stopPropagation();
            const $wrapper = jQuery(this).closest('.performance-musterdepot-dropdown-wrapper');

            if ($wrapper.hasClass('open')) {
                $wrapper.removeClass('open');
                $wrapper.find('.performance-musterdepot-dropdown-list').css({
                    'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
                });
                $wrapper.find('.performance-musterdepot-dropdown-icon').css('transform', 'rotate(0deg)');
                jQuery(this).css('background-color', 'white')
            } else {
                $wrapper.addClass('open');
                jQuery(this).next('.performance-musterdepot-dropdown-list').css({
                    'max-height': '500px', 'opacity': '1', 'pointer-events': 'auto',
                });
                jQuery(this).find('.performance-musterdepot-dropdown-icon').css('transform', 'rotate(180deg)');
                jQuery(this).css('background-color', '#F9FAFC')
            }
        });

        // Add click event to document to close dropdown if clicked outside of it
        jQuery(document).on('click', function (e) {
            const $wrapper = jQuery('.performance-musterdepot-dropdown-wrapper');

            if ($wrapper.hasClass('open')) {
                const $target = jQuery(e.target);
                if (!$target.closest('.performance-musterdepot-dropdown-wrapper').length) {
                    $wrapper.removeClass('open');
                    $wrapper.find('.performance-musterdepot-dropdown-list').css({
                        'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
                    });
                    $wrapper.find('.performance-musterdepot-dropdown-icon').css('transform', 'rotate(0deg)');
                    $wrapper.find('.performance-musterdepot-dropdown-title').css('background-color', 'white')
                }
            }
        });
    } else {
        jQuery('.performance-musterdepot-dropdown-title').on('mouseenter', function () {
            jQuery(this).css('background-color', '#F9FAFC');

            jQuery(this).next('.performance-musterdepot-dropdown-list').css({
                'max-height': '500px', 'opacity': '1', 'pointer-events': 'auto'
            });
            jQuery(this).find('.performance-musterdepot-dropdown-icon').css('transform', 'rotate(180deg)');
        });
        jQuery('.performance-musterdepot-dropdown-wrapper').on('mouseleave', function () {
            jQuery(this).find('.performance-musterdepot-dropdown-title').css('background-color', 'white');

            jQuery(this).find('.performance-musterdepot-dropdown-list').css({
                'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
            });
            jQuery(this).find('.performance-musterdepot-dropdown-icon').css('transform', 'rotate(0deg)');
        });
    }

    dropdownItem.on('click', function () {
        const thisDropdownItem = $(this);
        dropdownItem.removeClass('active');
        thisDropdownItem.addClass('active');
        selectedItemContainer.html(thisDropdownItem.text());

        // performance-musterdepot-dropdown-item has the attribute data-value
        chartMusterdepot(thisDropdownItem.data('value'));

        // close dropdown
        const $wrapper = jQuery('.performance-musterdepot-dropdown-wrapper');
        $wrapper.removeClass('open');  // Remove the open state
        $wrapper.find('.performance-musterdepot-dropdown-list').css({
            'max-height': '0', 'opacity': '0', 'pointer-events': 'none'
        });
        $wrapper.find('.performance-musterdepot-dropdown-icon').css('transform', 'rotate(0deg)');
        $wrapper.find('.performance-musterdepot-dropdown-title').css('background-color', 'white');
    })
}

// The reason for toggling the active class and toggling css is that the active class toggle is behaving different in firefox and chrome
// Probably a bad solution and should be refactored later
function initMobileDropdownBlog() {
    if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
        const $document = jQuery(document);
        const $checkboxContainers = jQuery('.checkboxes-container');
        const $dropdownWrapper = jQuery('.custom-sort-dropdown-wrapper');
        const $icon = $dropdownWrapper.find('.custom-sort-dropdown-icon');
        const $list = $dropdownWrapper.find('.custom-sort-dropdown-list');

        function resetCategoriesAndTags() {
            $checkboxContainers.removeClass('active');
            $checkboxContainers.css('background-color', 'unset');

            $checkboxContainers.find('.dropdown-content').css({
                'width': '', 'opacity': '0', 'background': ''
            });

            $checkboxContainers.find('.dropdown-content').find('.checkbox-wrapper').css('display', 'none');
            $checkboxContainers.find('.dropdown-trigger').find('.dropdown-icon').css('transform', 'rotate(0deg)');
            $checkboxContainers.find('.dropdown-trigger').find('span').css('background', '#ECEFF4');
        }

        function activateCategoriesAndTags(clickedDropdown) {
            resetBlogSortDropdown();

            const $clickedDropdown = jQuery(clickedDropdown);
            $clickedDropdown.addClass('active');
            $clickedDropdown.css('background-color', 'rgba(191, 208, 226, 0.4)');

            $clickedDropdown.find('.dropdown-content').css({
                'width': '100%', 'opacity': '1', 'background': '#FFFFFF'
            });

            $clickedDropdown.find('.dropdown-content').find('.checkbox-wrapper').css('display', 'flex');
            $clickedDropdown.find('.dropdown-trigger').find('.dropdown-icon').css('transform', 'rotate(180deg)');
            $clickedDropdown.find('.dropdown-trigger').find('span').css('background', '#BFD0E2');
        }

        function resetBlogSortDropdown() {
            $dropdownWrapper.removeClass('active');
            $icon.css('transform', 'rotate(0deg)');
            $dropdownWrapper.css('background-color', 'white');
            $list.css({
                'opacity': '0', 'pointer-events': 'none'
            });
        }

        function activateBlogSortDropdown() {
            resetCategoriesAndTags();
            $dropdownWrapper.addClass('active');
            $icon.css('transform', 'rotate(180deg)');
            $dropdownWrapper.css('background-color', 'rgba(191, 208, 226, 0.4)');
            $list.css({
                'opacity': '1',
                'transform': 'translateY(0)',
                'pointer-events': 'auto',
                'cursor': 'pointer',
                'background-color': '#FFFFFF'
            });
        }

        $document.on('click', '.checkboxes-container', function (e) {
            e.stopPropagation();
            if (jQuery(this).hasClass('active')) {
                resetCategoriesAndTags();
            } else {
                resetBlogSortDropdown();
                resetCategoriesAndTags();
                activateCategoriesAndTags(this);
            }
        });

        $document.on('click', '.custom-sort-dropdown-wrapper', function (e) {
            e.stopPropagation();
            if ($dropdownWrapper.hasClass('active')) {
                resetBlogSortDropdown();
            } else {
                resetCategoriesAndTags();
                activateBlogSortDropdown();
            }
        });

        $document.on('click', '.checkbox-wrapper', function (e) {
            e.stopPropagation();
        });

        $document.on('click', function (e) {
            if (!jQuery(e.target).closest('.checkboxes-container, .checkbox-wrapper').length) {
                resetCategoriesAndTags();
            }
            if (!jQuery(e.target).closest('.custom-sort-dropdown-wrapper').length) {
                resetBlogSortDropdown();
            }
        });
    }
}

function initReviewDropdown() {
    const dropdownItems = document.querySelectorAll('.review-dropdown .review-dropdown-item');
    const selectedItemContainer = document.querySelector('.review-dropdown #review-active-item');

    function toggleDropdown(element) {
        const wrapper = element.closest('.review-dropdown-wrapper');

        if (wrapper.classList.contains('open')) {
            wrapper.classList.remove('open');
            wrapper.querySelector('.review-dropdown-list').style = 'max-height: 0; opacity: 0; pointer-events: none;';
            wrapper.querySelector('.review-dropdown-icon').style.transform = 'rotate(0deg)';
            wrapper.style.backgroundColor = 'white';
        } else {
            wrapper.classList.add('open');
            element.nextElementSibling.style = 'max-height: 500px; opacity: 1; pointer-events: auto;';
            element.querySelector('.review-dropdown-icon').style.transform = 'rotate(180deg)';
            wrapper.style.backgroundColor = '#F9FAFC';
        }
    }

    if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
        document.querySelectorAll('.review-dropdown-title').forEach(title => {
            title.addEventListener('click', function (e) {
                e.stopPropagation();
                toggleDropdown(this);
            });
        });

        document.addEventListener('click', function (e) {
            const wrapper = document.querySelector('.review-dropdown-wrapper');

            if (wrapper && wrapper.classList.contains('open') && !e.target.closest('.review-dropdown-wrapper')) {
                toggleDropdown(wrapper.querySelector('.review-dropdown-title'));
            }
        });
    } else {
        document.querySelectorAll('.review-dropdown-title').forEach(title => {
            title.addEventListener('mouseenter', function () {
                document.querySelectorAll('.review-dropdown-wrapper').forEach(wrap => {
                    wrap.style.backgroundColor = '#F9FAFC';
                });

                this.nextElementSibling.style = 'max-height: 500px; opacity: 1; pointer-events: auto;';
                this.querySelector('.review-dropdown-icon').style.transform = 'rotate(180deg)';
            });
        });

        document.querySelectorAll('.review-dropdown-wrapper').forEach(wrapper => {
            wrapper.addEventListener('mouseleave', function () {
                this.style.backgroundColor = 'white';
                this.querySelector('.review-dropdown-list').style = 'max-height: 0; opacity: 0; pointer-events: none;';
                this.querySelector('.review-dropdown-icon').style.transform = 'rotate(0deg)';
            });
        });
    }

    dropdownItems.forEach(item => {
        item.addEventListener('click', function () {
            dropdownItems.forEach(dItem => dItem.classList.remove('active'));
            this.classList.add('active');
            selectedItemContainer.textContent = this.textContent;
            document.querySelector('#hidden_review_active_category').value = this.textContent;
            selectedItemContainer.classList.add('activated-at-least-once');

            const wrapper = document.querySelector('.review-dropdown-wrapper');
            wrapper.classList.remove('open');
            wrapper.querySelector('.review-dropdown-list').style = 'max-height: 0; opacity: 0; pointer-events: none;';
            wrapper.querySelector('.review-dropdown-icon').style.transform = 'rotate(0deg)';
            wrapper.style.backgroundColor = 'white';
        });
    });
}
function loadSelectImgSrc(){
    const kontaktpage = jQuery('.page-template-page-kontakt');
    if (kontaktpage.length > 0){
        const icon = jQuery('.review-dropdown-icon');
        icon.attr("src", theme_directory +'/assets/images/icons/dropdown-grey.svg')
    }
}
